import React from 'react';
import {useNavigate} from "react-router-dom";
import {motion} from "framer-motion";
import {useAppStore} from "../data/AppStore";
import {shallow} from "zustand/shallow";
import {Button, ButtonType, Colors} from "../components";

const Error = () => {

    const [clearUSER] = useAppStore(
        (state) => [
            state.clearUSER,
        ], shallow)
    const navigate = useNavigate();


    return (
        <motion.div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
        >
            <h1>Oops...</h1>
            <p>There seems to be an error...</p> <br/>
            <motion.div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                width: '80%',
                maxWidth: 600,
            }}>
                <Button
                    label={'Back to Client Info'}
                    className={'NavButton'}
                    onClick={() => navigate('/', {replace: true})}
                    type={ButtonType.Reset}
                    colorTheme={Colors.Sage}
                />

                <Button
                    className={'LogoutButton'}
                    label={'Logout'}
                    onClick={clearUSER}
                    type={ButtonType.Logout}
                />
            </motion.div>
        </motion.div>
    )
}

export default Error;